const Terms = () => {
  return (
    <div style={{ width: '90%', maxWidth: 725, margin: 'auto' }}>
      <p>
        <strong>PRIVACY NOTICE     </strong>
      </p>
      <p>
        <strong>Last updated July 27, 2019 </strong> 
      </p>
      <p> </p>
      <p> </p>
      <p>
        Thank you for choosing to be part of our community at Tidal Market (“
        <strong>Company</strong>”, “<strong>we</strong>”, “<strong>us</strong>”,
        or “<strong>our</strong>”). We are committed to protecting your personal
        information and your right to privacy. If you have any questions or
        concerns about our notice, or our practices with regards to your
        personal information, please contact us at info@tidalmarket.com.
      </p>
      <p>
        When you visit our website 
        <a href="https://www.tidalmarket.com/">https://www.tidalmarket.com/</a>,
        and use our services, you trust us with your personal information. We
        take your privacy very seriously. In this privacy notice, we describe
        our privacy notice. We seek to explain to you in the clearest way
        possible what information we collect, how we use it and what rights you
        have in relation to it. We hope you take some time to read through it
        carefully, as it is important. If there are any terms in this privacy
        notice that you do not agree with, please discontinue use of
        our Sites and our services. 
      </p>
      <p>
        This privacy notice applies to all information collected through
        our website 
        <a href="https://www.tidalmarket.com">https://tidalmarket.com/</a>
        , and/or any related services, sales, marketing or events (we refer to
        them collectively in this privacy notice as the "
        <strong>Services</strong>").  
      </p>
      <p>
        <strong>
          Please read this privacy notice carefully as it will help you make
          informed decisions about sharing your personal information with us.  
        </strong>
         
      </p>
      <p> </p>
      <p>
        <strong>TABLE OF CONTENTS </strong> 
      </p>
      <ol>
        <li>WHAT INFORMATION DO WE COLLECT?</li>
        <li>HOW DO WE USE YOUR INFORMATION?</li>
        <li>WILL YOUR INFORMATION BE SHARED WITH ANYONE?</li>
        <li>DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</li>
        <li>HOW LONG DO WE KEEP YOUR INFORMATION?</li>
        <li>HOW DO WE KEEP YOUR INFORMATION SAFE?</li>
        <li>WHAT ARE YOUR PRIVACY RIGHTS?</li>
        <li>CONTROLS FOR DO-NOT-TRACK FEATURES</li>
        <li>DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</li>
        <li>DO WE MAKE UPDATES TO THIS POLICY?</li>
        <li>HOW CAN YOU CONTACT US ABOUT THIS POLICY? </li>
      </ol>
      <h1>
        <strong> WHAT INFORMATION DO WE COLLECT? </strong>
      </h1>
      <p>  </p>
      <p> </p>
      <p> </p>
      <ol start={2}>
        <li>
          <strong> HOW DO WE USE YOUR INFORMATION? </strong>
        </li>
      </ol>
      <p>
        <strong>
          <em>In Short: </em> 
        </strong>
        <em>
          We process your information for purposes based on legitimate business
          interests, the fulfillment of our contract with you, compliance with
          our legal obligations, and/or your consent.
        </em>
          
      </p>
      <p>
        We use personal information collected via our Services for a variety of
        business purposes described below. We process your personal information
        for these purposes in reliance on our legitimate business interests, in
        order to enter into or perform a contract with you, with your consent,
        and/or for compliance with our legal obligations. We indicate the
        specific processing grounds we rely on next to each purpose listed
        below. 
      </p>
      <p>  </p>
      <p>We use the information we collect or receive:  </p>
      <ul>
        <li>
          <strong>To facilitate account creation and logon process.</strong> If
          you choose to link your account with us to a third party account
          *(such as your Google or Facebook account), we use the information you
          allowed us to collect from those third parties to facilitate account
          creation and logon process for the performance of the
          contract.        
        </li>
        <li>
          <strong>To send you marketing and promotional communications.</strong>
           We and/or our third party marketing partners may use the personal
          information you send to us for our marketing purposes, if this is in
          accordance with your marketing preferences. You can opt-out of our
          marketing emails at any time (see the "WHAT ARE YOUR PRIVACY RIGHTS"
          below).         
        </li>
        <li>
          <strong>Fulfill and manage your orders.</strong> We may use your
          information to fulfill and manage your orders, payments, returns, and
          exchanges made through the Services.                
        </li>
        <li>
          <strong>Stripe Payment Processing</strong> Stripe collects identifying
          information about the devices that connect to its services. Stripe
          uses this information to operate and improve the services it provides
          to us, including for fraud detection. You can learn more about Stripe
          and read its privacy policy at
          https://stripe.com/privacy.                
        </li>
        <li>
          <strong>Request Feedback.</strong> We may use your information to
          request feedback and to contact you about your use of
          our Services.                  
        </li>
        <li>
          <strong>To protect our Services.</strong> We may use your information
          as part of our efforts to keep our Services safe and secure (for
          example, for fraud monitoring and prevention).                       
        </li>
        <li>
          <strong>
            To enforce our terms, conditions and policies for Business Purposes,
            Legal Reasons and Contractual.
          </strong>
                     
        </li>
        <li>
          <strong>To respond to legal requests and prevent harm. </strong>If we
          receive a subpoena or other legal request, we may need to inspect the
          data we hold to determine how to respond.                           
        </li>
        <li>
          <strong>To manage user accounts</strong>. We may use your information
          for the purposes of managing our account and keeping it in working
          order.  
          <br />                          
        </li>
        <li>
          <strong>To deliver services to the user.</strong> We may use your
          information to provide you with the requested service.   
        </li>
        <li>
          <strong>To respond to user inquiries/offer support to users.</strong> 
          We may use your information to respond to your inquiries and solve any
          potential issues you might have with the use of our Services.   
        </li>
        <li>
          <strong>For other Business Purposes.</strong> We may use your
          information for other Business Purposes, such as data analysis,
          identifying usage trends, determining the effectiveness of our
          promotional campaigns and to evaluate and improve our Services,
          products, marketing and your experience. We may use and store this
          information in aggregated and anonymized form so that it is not
          associated with individual end users and does not include personal
          information. We will not use identifiable personal information without
          your consent.                             
        </li>
      </ul>
      <ol start={3}>
        <li>
          <strong> WILL YOUR INFORMATION BE SHARED WITH ANYONE? </strong>
        </li>
      </ol>
      <p>
        <strong>
          <em>In Short: </em> 
        </strong>
        <em>
          We only share information with your consent, to comply with laws, to
          provide you with services, to protect your rights, or to fulfill
          business obligations. 
        </em>
          
      </p>
      <p> </p>
      <p>We may process or share data based on the following legal basis:</p>
      <ul>
        <li>
          <strong>Consent:</strong> We may process your data if you have given
          us specific consent to use your personal information in a specific
          purpose. 
        </li>
        <li>
          <strong>Legitimate Interests:</strong> We may process your data when
          it is reasonably necessary to achieve our legitimate business
          interests. 
        </li>
        <li>
          <strong>Performance of a Contract: </strong>Where we have entered into
          a contract with you, we may process your personal information to
          fulfill the terms of our contract. 
        </li>
        <li>
          <strong>Legal Obligations:</strong> We may disclose your information
          where we are legally required to do so in order to comply with
          applicable law, governmental requests, a judicial proceeding, court
          order, or legal process, such as in response to a court order or a
          subpoena (including in response to public authorities to meet national
          security or law enforcement requirements). 
        </li>
        <li>
          <strong>Vital Interests:</strong> We may disclose your information
          where we believe it is necessary to investigate, prevent, or take
          action regarding potential violations of our policies, suspected
          fraud, situations involving potential threats to the safety of any
          person and illegal activities, or as evidence in litigation in which
          we are involved.
        </li>
      </ul>
      <p>
        More specifically, we may need to process your data or share your
        personal information in the following situations:  
      </p>
      <ul>
        <li>
          <strong>
            Vendors, Consultants and Other Third-Party Service Providers.
          </strong>
           We may share your data with third party vendors, service providers,
          contractors or agents who perform services for us or on our behalf and
          require access to such information to do that work. Examples include:
          payment processing, data analysis, email delivery, hosting services,
          customer service and marketing efforts. We may allow selected third
          parties to use tracking technology on the Services, which will enable
          them to collect data about how you interact with the Services over
          time. This information may be used to, among other things, analyze and
          track data, determine the popularity of certain content and better
          understand online activity. Unless described in this Policy, we do not
          share, sell, rent or trade any of your information with third parties
          for their promotional purposes.   
        </li>
        <li>
          <strong>Business Transfers.</strong> We may share or transfer your
          information in connection with, or during negotiations of, any merger,
          sale of company assets, financing, or acquisition of all or a portion
          of our business to another company.
        </li>
        <li>
          <strong>Third-Party Advertisers.</strong> We may use third-party
          advertising companies to serve ads when you visit the Services. These
          companies may use information about your visits to our Website(s) and
          other websites that are contained in web cookies and other tracking
          technologies in order to provide advertisements about goods and
          services of interest to you.        
        </li>
      </ul>
      <p> </p>
      <p>     </p>
      <p> </p>
      <ol start={4}>
        <li>
          <strong> DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES? </strong>
        </li>
      </ol>
      <p>
        <strong>
          <em>In Short: </em> 
        </strong>
        <em>
          We may use cookies and other tracking technologies to collect and
          store your information.
        </em>
          
      </p>
      <p>
        We may use cookies and similar tracking technologies (like web beacons
        and pixels) to access or store information. Specific information about
        how we use such technologies and how you can refuse certain cookies is
        set out in our Cookie Policy.         
      </p>
      <p> </p>
      <ol start={5}>
        <li>
          <strong> HOW LONG DO WE KEEP YOUR INFORMATION? </strong>
        </li>
      </ol>
      <p>
        <strong>
          <em>In Short: </em> 
        </strong>
        <em>
          We keep your information for as long as necessary to fulfill the
          purposes outlined in this privacy notice unless otherwise required by
          law. 
        </em>
          
      </p>
      <p>
        We will only keep your personal information for as long as it is
        necessary for the purposes set out in this privacy notice, unless a
        longer retention period is required or permitted by law (such as tax,
        accounting or other legal requirements). No purpose in this policy will
        require us keeping your personal information for longer than 6 months
        past the termination of the user's account .  
      </p>
      <p>
        When we have no ongoing legitimate business need to process your
        personal information, we will either delete or anonymize it, or, if this
        is not possible (for example, because your personal information has been
        stored in backup archives), then we will securely store your personal
        information and isolate it from any further processing until deletion is
        possible.   
      </p>
      <p> </p>
      <ol start={6}>
        <li>
          <strong> HOW DO WE KEEP YOUR INFORMATION SAFE?  </strong>
        </li>
      </ol>
      <p>
        <strong>
          <em>In Short: </em> 
        </strong>
        <em>
          We aim to protect your personal information through a system of
          organizational and technical security measures.
        </em>
          
      </p>
      <p>
        We have implemented appropriate technical and organizational security
        measures designed to protect the security of any personal information we
        process. However, please also remember that we cannot guarantee that the
        internet itself is 100% secure. Although we will do our best to protect
        your personal information, transmission of personal information to and
        from our Services is at your own risk. You should only access the
        services within a secure environment.   
      </p>
      <p> </p>
      <ol start={7}>
        <li>
          <strong> WHAT ARE YOUR PRIVACY RIGHTS? </strong>
        </li>
      </ol>
      <p>
        <strong>
          <em>In Short: </em> 
        </strong>
        <em>
          In some regions, such as the European Economic Area, you have rights
          that allow you greater access to and control over your personal
          information. You may review, change, or terminate your account at any
          time.
        </em>
           
      </p>
      <p>
        In some regions (like the European Economic Area), you have certain
        rights under applicable data protection laws. These may include the
        right (i) to request access and obtain a copy of your personal
        information, (ii) to request rectification or erasure; (iii) to restrict
        the processing of your personal information; and (iv) if applicable, to
        data portability. In certain circumstances, you may also have the right
        to object to the processing of your personal information. To make such a
        request, please use the contact details provided below. We will consider
        and act upon any request in accordance with applicable data protection
        laws. 
      </p>
      <p>
        If we are relying on your consent to process your personal information,
        you have the right to withdraw your consent at any time. Please note
        however that this will not affect the lawfulness of the processing
        before its withdrawal.   
      </p>
      <p>
        If you are resident in the European Economic Area and you believe we are
        unlawfully processing your personal information, you also have the right
        to complain to your local data protection supervisory authority. You can
        find their contact details here: 
        <a href="http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm">
          http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm
        </a>
          
        <br />  
      </p>
      <p>
        <strong>Account Information</strong>  
      </p>
      <p>
        If you would at any time like to review or change the information in
        your account or terminate your account, you can:
      </p>
      <p>■  Log into your account settings and update your user account.</p>
      <p>
        Upon your request to terminate your account, we will deactivate or
        delete your account and information from our active databases. However,
        some information may be retained in our files to prevent fraud,
        troubleshoot problems, assist with any investigations, enforce our Terms
        of Use and/or comply with legal requirements.
      </p>
      <p>
        <strong>
          <u>Cookies and similar technologies:</u> 
        </strong>
        Most Web browsers are set to accept cookies by default. If you prefer,
        you can usually choose to set your browser to remove cookies and to
        reject cookies. If you choose to remove cookies or reject cookies, this
        could affect certain features or services of our Services.
      </p>
      <p>
        <strong>
          <u>Opting out of email marketing:</u> 
        </strong>
        You can unsubscribe from our marketing email list at any time by
        clicking on the unsubscribe link in the emails that we send or by
        contacting us using the details provided below. You will then be removed
        from the marketing email list – however, we will still need to send you
        service-related emails that are necessary for the administration and use
        of your account. To otherwise opt-out, you may:
      </p>
      <p>
        ■  Note your preferences when you register an account with the site.
      </p>
      <p>■  Access your account settings and update preferences.  </p>
      <p> </p>
      <ol start={8}>
        <li>
          <strong> CONTROLS FOR DO-NOT-TRACK FEATURES </strong>
        </li>
      </ol>
      <p>
        Most web browsers and some mobile operating systems and mobile
        applications include a Do-Not-Track (“DNT”) feature or setting you can
        activate to signal your privacy preference not to have data about your
        online browsing activities monitored and collected. No uniform
        technology standard for recognizing and implementing DNT signals has
        been finalized. As such, we do not currently respond to DNT browser
        signals or any other mechanism that automatically communicates your
        choice not to be tracked online. If a standard for online tracking is
        adopted that we must follow in the future, we will inform you about that
        practice in a revised version of this privacy notice.
      </p>
      <p> </p>
      <ol start={9}>
        <li>
          <strong>
            {' '}
            DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS? 
          </strong>
        </li>
      </ol>
      <p>
        <strong>
          <em>In Short: </em> 
        </strong>
        <em>
          Yes, if you are a resident of California, you are granted specific
          rights regarding access to your personal information. 
        </em>
          
      </p>
      <p>
        California Civil Code Section 1798.83, also known as the “Shine The
        Light” law, permits our users who are California residents to request
        and obtain from us, once a year and free of charge, information about
        categories of personal information (if any) we disclosed to third
        parties for direct marketing purposes and the names and addresses of all
        third parties with which we shared personal information in the
        immediately preceding calendar year. If you are a California resident
        and would like to make such a request, please submit your request in
        writing to us using the contact information provided below. 
      </p>
      <p>
        If you are under 18 years of age, reside in California, and have a
        registered account with the Services, you have the right to request
        removal of unwanted data that you publicly post on the Services. To
        request removal of such data, please contact us using the contact
        information provided below, and include the email address associated
        with your account and a statement that you reside in California. We will
        make sure the data is not publicly displayed on the Services, but please
        be aware that the data may not be completely or comprehensively removed
        from our systems.
      </p>
      <p> </p>
      <ol start={10}>
        <li>
          <strong> DO WE MAKE UPDATES TO THIS POLICY? </strong>
        </li>
      </ol>
      <p>
        <strong>
          <em>In Short: </em> 
        </strong>
        <em>
          Yes, we will update this policy as necessary to stay compliant with
          relevant laws.
        </em>
          
      </p>
      <p>
        We may update this privacy notice from time to time. The updated version
        will be indicated by an updated “Revised” date and the updated version
        will be effective as soon as it is accessible. If we make material
        changes to this privacy notice, we may notify you either by prominently
        posting a notice of such changes or by directly sending you a
        notification. We encourage you to review this privacy notice frequently
        to be informed of how we are protecting your information.  
      </p>
      <p> </p>
      <ol start={11}>
        <li>
          <strong> HOW CAN YOU CONTACT US ABOUT THIS POLICY? </strong>
        </li>
      </ol>
      <p>
        If you have questions or comments about this policy, you may email us at
        info@tidalmarket.com or by post to:
        <br /> <br /> TIDAL MARKET INC.
      </p>
      <p>PO Box 250494</p>
      <p>West Bloomfield, MI 48324</p>
      <p> </p>
    </div>
  );
};

export default Terms;
